import React from 'react';
import PropTypes from 'prop-types';

import CloseButton from '../../../formElements/CloseButton';
import StaticField from '../../../formElements/StaticField';

import expand from '../../../../commonStyles/rowExpand.module.css';

const SignPostingRowDetails = ({ row, onClose }) => {
    return (
        <div className={expand.rowDropdown}>
            <StaticField
                id={row.id}
                label="Notes"
                content={row.notes || 'No notes found'}
                customClass="info"
            />
            <CloseButton id="signPostingRowDetailButton" onClose={onClose} />
        </div>
    );
};

SignPostingRowDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default SignPostingRowDetails;
